import { getFullMonthName } from '@/helpers';
import { Achievement } from '@/models';
import { Badge, SummerAchievement, SummerCampaign } from '@/models/leaderboard';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

const MAX_BADGE_SLOTS = 7;

interface BadgePanelSlot {
  slotNumber: number;
  achievement?: Badge;
  achieved: boolean;
  imageUrl: string;
}

@Component({
  name: 'CmgLeaderboardBadgePanel',
})
export default class CmgLeaderboardBadgePanel extends Vue {
  @Prop({ required: true })
  campaign!: SummerCampaign;  

  @Prop({ required: true })
  achievements!: SummerAchievement;    

  get month(): string {
    return getFullMonthName(new Date(2000, this.campaign.month, 1));
  }

  get badgeSlots(): BadgePanelSlot[] {
    return Array.from({ length: MAX_BADGE_SLOTS }, (_, index) => {
      const slotNumber = index + 1;
      const achievement = this.getBadgeAchievement(slotNumber);

      return {
        slotNumber,
        achievement,
        achieved: achievement !== undefined,
        imageUrl: achievement?.imageUrl || this.getCampaignBadgeSlotImage(slotNumber),
      };
    });
  }

  private getBadgeAchievement(slotNumber: number): Badge | undefined {
    return this.achievements.badges.find(x => x.badgeSlot === `${this.month}${slotNumber}`);
  }

  private getCampaignBadgeSlotImage(slotNumber: number): string {
    const campaignMilestone = this.campaign.milestones.find(x => x.segment === slotNumber);

    return typeof campaignMilestone?.mediaUriInactive === 'string' ? campaignMilestone.mediaUriInactive : '';
  }

  onClickBadge(badge: Badge) {
    if (badge !== undefined) {
      const achievement: Achievement = {
        title: badge.title,
        description: badge.description,
        achievementDate: badge.achievementDate,
        mediaUri: badge.imageUrl,
        achievementId: '',
        tagLine: '',
        medallionText: '',
        pointsEarned: 0,
        shareText: '',
        badgeType: 'extra'
      };
      this.$services.ui.setModalVisibility('achievedBadge', true, { achievement: achievement });
    }
  }
}
